const settings = {
    appName: process.env.VUE_APP_NAME,
    endPoint: process.env.VUE_APP_ENPOINT_BACKEND,
    endPointApp: process.env.VUE_APP_ENPOINT_APP,
    appType: process.env.VUE_APP_ENV,
    jwtSecret:process.env.VUE_APP_JWT_SECRET,
  }

export default settings;